export default from './new-post-message-root';



// WEBPACK FOOTER //
// ./app/containers/new-post-message-root/index.js